import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { IPotentialValuesPayloadState } from '@app-store/slices/companyStatistics/potentialValues'

interface TaskAction extends Action {
    payload: IPotentialValuesPayloadState
}

const { onRequest, onSuccess, onFailure } = rootActions.companyStatistics.potentialValues

function* potentialValuesSagaTask({ payload }: TaskAction) {
    try {
        const response = yield axios.get(`/companies/stats/potential-values`)
        if (response.success) {
            yield put(onSuccess(response.result.data))
            yield payload?.sagaCB && payload.sagaCB?.onSuccess()
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
        yield payload?.sagaCB && payload.sagaCB?.onError()
    }
}

function* potentialValuesSaga(): any {
    yield takeLatest<TaskAction>(onRequest, potentialValuesSagaTask)
}

export default potentialValuesSaga
